"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapeDiverResponseError = void 0;
const api_geometry_api_dto_v2_1 = require("@shapediver/api.geometry-api-dto-v2");
const sdk_geometry_api_sdk_core_1 = require("@shapediver/sdk.geometry-api-sdk-core");
class ShapeDiverResponseError extends sdk_geometry_api_sdk_core_1.ShapeDiverError {
    constructor(e) {
        super(e.message);
        this.errorType = sdk_geometry_api_sdk_core_1.ShapeDiverErrorType.Response;
        this.status = e.status;
        this.desc = e.desc;
        this.error = Object.values(api_geometry_api_dto_v2_1.ShapeDiverResponseErrorType).includes(e.error)
            ? e.error
            : api_geometry_api_dto_v2_1.ShapeDiverResponseErrorType.UNKNOWN;
    }
}
exports.ShapeDiverResponseError = ShapeDiverResponseError;
//# sourceMappingURL=ShapeDiverErrors.js.map